import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { MaterialModule } from 'src/material/material.module';

import { InternalHeaderComponent } from './headers/internal-header/internal-header.component';
import { NavigationComponent } from './navigation/navigation.component';
import { ChartsModule } from "ng2-charts";
import { LoaderComponent } from "./loader/loader.component"
import { PieChartCNPComponent } from './pie-chart-cnp/pie-chart-cnp.component';
import { SafeUrlPipe } from '../utils/safeUrlPipe/safe-url.pipe';
import { DateSortPipe } from '../utils/dateSort/date-sort.pipe';
import { DateRangePickerSelectionStrategy } from './range-selection-strategy/range-selection-strategy.component';
import { MonthAndYearPickerComponent } from './month-and-year-picker/month-and-year-picker.component';
import { ReactiveFormsModule } from '@angular/forms';
import { PdfViewerModule } from 'ng2-pdf-viewer';
import { PdfViewerComponent } from './pdf-viewer/pdf-viewer.component';
import { LineGraphComponent } from './line-graph/line-graph.component';
import { PaginatorComponent } from './paginator/paginator.component';
import { ErrorMessageComponent } from './error-message/error-message.component';
import { PieChartCPComponent } from './pie-chart-cp/pie-chart-cp.component';
import { ReturnComponent } from './return/return.component';
import { SmallLoaderComponent } from './small-loader/small-loader.component';
import { ReplyMessagePopupComponent } from './reply-message-popup/reply-message-popup.component';

@NgModule({
    declarations: [
        InternalHeaderComponent,
        NavigationComponent,
        LoaderComponent,
        PieChartCNPComponent,
        PieChartCPComponent,
        SafeUrlPipe,
        DateSortPipe,
        DateRangePickerSelectionStrategy,
        MonthAndYearPickerComponent,
        PdfViewerComponent,
        LineGraphComponent,
        PaginatorComponent,
        ErrorMessageComponent,
        ReturnComponent,
        SmallLoaderComponent,
        ReplyMessagePopupComponent
    ],
    exports: [
        InternalHeaderComponent,
        NavigationComponent,
        LoaderComponent,
        PieChartCNPComponent,
        PieChartCPComponent,
        SafeUrlPipe,
        DateSortPipe,
        DateRangePickerSelectionStrategy,
        MonthAndYearPickerComponent,
        PdfViewerComponent,
        LineGraphComponent,
        PaginatorComponent,
        ErrorMessageComponent,
        ReturnComponent,
        SmallLoaderComponent,
        ReplyMessagePopupComponent
    ],
    imports: [
        RouterModule,
        CommonModule,
        MaterialModule,
        ChartsModule,
        ReactiveFormsModule,
        PdfViewerModule,
    ]
  })

export class sharedModule {
}
